module.exports = __webpack_public_path__ + "assets/img/btn-view-mecha-info-993cb2f1.png";